import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade19,
  blackShade21,
  greenColor02,
  greenColor03,
  greyColor48,
  lightGreen02,
  lightGreen03,
  whiteColor,
  yellowColor,
} from "../../configs/styles/muiThemes";
import { useNavigate } from "react-router-dom";
import PublishedWithChangesOutlinedIcon from "@mui/icons-material/PublishedWithChangesOutlined";

const InventoryUpdateSuccessful = ({ publishedInfo, isCatalogPartner }) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography sx={styles.heading}>Import {isCatalogPartner ? "Pricing" : "Inventory/Pricing"}</Typography>

      <Grid container>
        <Grid item xs={12} md={7}>
          <Box sx={styles.card}>
            <Typography sx={{ ...styles.heading, fontSize: 15, mb: 2 }}>
              Successfully imported {isCatalogPartner ? "Pricing" : "Inventory/Pricing"} details
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                p: "10px 18px",
                borderRadius: "13px",
                backgroundColor: lightGreen02,
                border: `1px solid ${lightGreen03}`,
                mb: 3,
              }}
            >
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "20px",
                  backgroundColor: whiteColor,
                }}
              >
                <PublishedWithChangesOutlinedIcon
                  sx={{ fontSize: "20px", color: greenColor03 }}
                />
              </Box>

              <Box>
                <Typography
                  fontSize={11.2}
                  fontWeight={500}
                  color={greyColor48}
                  lineHeight="15px"
                >
                  NO OF PRODUCTS UPDATED
                </Typography>
                <Typography fontSize={15} fontWeight={600} color={blackShade19}>
                  {publishedInfo || "-"}
                </Typography>
              </Box>
            </Box>

            <Button
              variant="contained"
              sx={styles.nextBtn}
              disableElevation
              onClick={() => {
                navigate(`/${sessionStorage.getItem("costboWEBURL")}/allStock`);
              }}
            >
              GO TO ACTIVE INVENTORY
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InventoryUpdateSuccessful;

const styles = {
  heading: {
    fontSize: "14px",
    fontWeight: "600",
    color: blackShade19,
    mb: 1,
  },

  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${greenColor02}`,
    borderRadius: "10px",
    padding: "20px",
  },

  nextBtn: {
    fontSize: 13,
    fontWeight: 500,
    color: blackColor,
    backgroundColor: yellowColor,
    border: `1px solid ${yellowColor}`,
    padding: "7px 30px",
    borderRadius: "7px",
    "&:hover": {
      color: yellowColor,
      backgroundColor: whiteColor,
    },
  },
};
